// extracted by mini-css-extract-plugin
export default {"cls1":"PaperSelector-cls1___4b6c9f568fb085ecb1e","cls2":"PaperSelector-cls2___3f4b3417a06fbde18cc PaperSelector-cls1___4b6c9f568fb085ecb1e"};